import { useDispatch, useSelector } from "react-redux";
import { LOADING_RESOURCES, RESOURCES } from "../store/selectors";
import { useEffect } from "react";
import { App } from "antd";
import { setLoading, setResources, deleteResource as deleteResourceAction } from "../store/slices/resource";
import {
  getResources,
  getResourceById as getResourceByIdService,
  deleteResource as deleteResourceService,
} from "../services/resources/resources.service";

export const useResources = () => {
  // From App.useApp(): the static notification does not render under React 19.
  const { notification } = App.useApp();
  const dispatch = useDispatch();
  const resources = useSelector(RESOURCES);
  const loading = useSelector(LOADING_RESOURCES);

  const fetchInfo = async () => {
    dispatch(setLoading(true));
    try {
      if (resources?.length > 0) {
        setResources(resources);
      } else {
        const resourcesResponse = await getResources();
        resourcesResponse && dispatch(setResources(resourcesResponse));
      }
      dispatch(setLoading(false));
    } catch (error: any) {
      dispatch(setLoading(false));
      notification["error"]({
        message: "Error",
        description:
          "La información no pudo ser cargada, por favor notifica éste error!",
        placement: "top",
        duration: 3,
      });
      throw new Error(error);
    }
  };

  const getResourceById = async (id: number) => {
    try {
      const response = await getResourceByIdService(id);
      return response;
    } catch (error: any) {
      // Caller owns the error UX; rethrow the original error so it can read
      // error.response.data.message.
      console.error("Error getting resource by ID:", error);
      throw error;
    }
  };

  const deleteResource = async (id: number): Promise<boolean> => {
    dispatch(setLoading(true));
    try {
      await deleteResourceService(id);
      notification["success"]({
        message: "Eliminación Exitosa",
        description: "El recurso fue eliminado con éxito!",
        placement: "top",
        duration: 3,
      });
      dispatch(deleteResourceAction(id));
      dispatch(setLoading(false));
      return true;
    } catch (error: any) {
      dispatch(setLoading(false));
      notification["error"]({
        message: "Eliminación Erronea",
        description:
          error?.response?.data?.message || "El recurso no pudo ser eliminado!",
        placement: "top",
        duration: 3,
      });
      return false;
    }
  };

  useEffect(() => {
    fetchInfo();
  }, []);

  return {
    loading,
    resources,
    deleteResource,
    getResourceById,
    // Exposes the existing fetch so callers (e.g. the delete-undo restore
    // flow) can refresh the list; this hook otherwise only relies on Redux
    // updates after delete.
    refetch: fetchInfo,
  };
};
